import {
  getApplicationByEdition,
  GetApplicationByEditionRequestParams,
} from "@/requests/applications/application-by-edition.request";
import { useQuery } from "@tanstack/react-query";

export const useApplicationByEdition = (
  params: GetApplicationByEditionRequestParams,
) => {
  return useQuery({
    queryKey: ["applications", "edition", params.editionId],
    queryFn: () => getApplicationByEdition(params),
    enabled: !!params.editionId && !!params.companyId,
    retry: false,
  });
};
